var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18H3.83333C3.36662 18 3.13327 18 2.95501 17.9092C2.79821 17.8293 2.67072 17.7018 2.59083 17.545C2.5 17.3667 2.5 17.1334 2.5 16.6667V3M16.6667 7.16667L13.4009 10.6522C13.2772 10.7843 13.2153 10.8504 13.1406 10.8845C13.0747 10.9146 13.0021 10.9271 12.93 10.9206C12.8482 10.9132 12.7679 10.8715 12.6072 10.7881L9.89277 9.3786C9.73212 9.29519 9.65179 9.25348 9.57003 9.24611C9.49787 9.23961 9.42526 9.25204 9.35936 9.28217C9.28471 9.31631 9.22282 9.38236 9.09906 9.51445L5.83333 13",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetStatus);
export default __webpack_public_path__ + "static/media/assetStatus.6aed613b1ebdbe729452a9271416a46e.svg";
export { ForwardRef as ReactComponent };